import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import useDateFormat from "../../../hooks/useDateFormat";
import DeleteIcon from "@mui/icons-material/Delete";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import BannerModal from "./modal/BannerModal";
import DeleteAcademyModal from "../academy/modal/DeleteAcademyModal";
import useBanner from "../../../hooks/useBanner";

export const BannerCard = ({ banner, triggerFetchBanner }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [isOn, setIsOn] = useState(banner?.isActive);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const { formatDate } = useDateFormat();
  const { toggleBanner } = useBanner();
  const [openBanner, setOpenBanner] = useState(false);

  const handleToggle = async () => {
    const newState = !isOn;
    setIsOn(newState);
    try {
      await toggleBanner(setLoading, banner._id);
    } catch (error) {
      console.error("Failed to update banner:", error);
      setIsOn(!newState);
    }
  };
  return (
    <>
      <div className="relative bg-white shadow-md rounded-lg overflow-hidden">
        <img
          src={banner.image}
          alt={banner.title}
          className="w-full h-40 object-cover"
          onError={(e) => console.error("Image load failed:", e.target.src)}
        />
        <div className="p-4 bg-[#F1F1F1] flex justify-between ">
          <div>
            <h3 className="text-sm font-semibold text-gray-800">
              {banner.title}
            </h3>
            <div className="flex flex-col mt-1">
              <span className="text-xs font-medium text-gray-800">
                {banner.description}
              </span>
              <span className="text-xs  text-gray-800 mt-1">
                Created at: {formatDate(banner.createdAt)}
              </span>
            </div>
          </div>

          <div
            className="flex items-center cursor-pointer"
            onClick={handleToggle}
          >
            <img
              src={isOn ? "/toggleIconOn.svg" : "/toggleIconOff.svg"}
              alt="toggle icon"
              className="size-8"
            />
          </div>
        </div>
        <div
          onClick={() => setOpenDeleteModal(true)}
          className="absolute top-3 right-3 bg-white rounded-full p-[2px] flex items-center justify-center cursor-pointer"
        >
          <DeleteIcon className="text-red-500" fontSize="small" />
        </div>
        <div
          onClick={() => setOpenBanner(true)}
          className="absolute top-3 right-11 bg-white rounded-full p-[2px] flex items-center justify-center cursor-pointer"
        >
          <ModeEditIcon fontSize="small" className="cursor-pointer " />
        </div>
      </div>
      {openDeleteModal && (
        <DeleteAcademyModal
          onTrigger={triggerFetchBanner}
          modalName={"Banner"}
          setOpenDeleteModal={setOpenDeleteModal}
          name={banner?.title}
          accademyCategory={4}
          createdBy={banner?.trainersName}
          id={banner?._id}
        />
      )}

      {openBanner && (
        <BannerModal
          onTrigger={triggerFetchBanner}
          setOpenBanner={setOpenBanner}
          banner={banner}
        />
      )}
    </>
  );
};
